import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { resetGuestSummaryReport } from '../../../actions/reports/guest-summary';
import { fetchGuestSummaryReport } from '../../../sagas/reports/guest-summary/routines';

const initialState = {
  all: [],
  fetching: false,
  fetched: false,
  fetchingError: null
};

const fetchGuestSummaryReportHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('all', response.items, state),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const resetGuestSummaryReportHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchGuestSummaryReportHandler(fetchGuestSummaryReport),
  ...resetGuestSummaryReportHandler(resetGuestSummaryReport)
});
